import { Component, Input } from '@angular/core';
import { AuthenticationService } from '@app/_services/authentication.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { TranslateHelper } from '@app/_helpers';
import { ClickDirective } from '../../../shared/directives/click.directive';
import { SocialShareButtonsComponent } from '../../share-buttons/social-share-buttons.component';
import { MatTabsModule } from '@angular/material/tabs';
import { MatIconModule } from '@angular/material/icon';
import { NgIf, NgFor, DatePipe } from '@angular/common';
import { SiteService } from '@app/_services/site.service';
import { RatingComponent } from '../../../shared/components/rating/rating.component';
import { ProfessionalReviewDialogComponent } from './professional-review-dialog/professional-review-dialog.component';
import { CurrencyRateService } from '@services/currency-rate.service';
import { CurrencyConvertPipe } from '../../../shared/pipes/currency-convert.pipe';
import { ImageInterface } from '@app/_interfaces/image.interface';
import { ProfessionalServiceItem } from '@interfaces/professional-booking';
import { ProfessionalServiceCardComponent } from '../professional-service-card/professional-service-card.component';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';



export type ProductLayout = 'standard' | 'sidebar' | 'columnar' | 'quickview';
@UntilDestroy()
@Component({
    selector: 'app-professional-service',
    templateUrl: './professional-service.component.html',
    styleUrls: ['./professional-service.component.scss'],
    providers: [TranslateHelper],
    standalone: true,
    imports: [NgIf, NgFor, MatIconModule, MatTabsModule, SocialShareButtonsComponent, ClickDirective, TranslateModule, RatingComponent, DatePipe,
        CurrencyConvertPipe, ProfessionalServiceCardComponent]
})
export class ProfessionalServiceComponent {
    userDetails: any;

    constructor(
        private authService: AuthenticationService,
        public translate: TranslateService,
        public translateHelper: TranslateHelper,
        private modalService: BsModalService,
        public siteService: SiteService,
        public currencyRate: CurrencyRateService
    ) { }
    @Input() layout: ProductLayout;

    @Input() product: any;

    // Each service is booked from its own page (booking plan §1.1); the profile only lists them as cards
    @Input() services: ProfessionalServiceItem[] = [];

    @Input() professional;

    image = 'assets/images/nologo.png';


    ngOnInit(): void {
        this.userDetails = this.authService.currentUserValue;
        this.authService.currentUser.pipe(untilDestroyed(this)).subscribe((user)=>{
            this.userDetails = user;
        })
    }

    get locationLabel(): string {
        const address = this.professional?.profession?.address;
        return [address?.country, address?.city].filter((part) => !!part).join(', ');
    }

    get bio(): string {
        return this.translateHelper.localize(this.professional?.profession?.bio);
    }

    get companyName(): string {
        return this.translateHelper.localize(this.professional?.profession?.companyName);
    }

    get portfolioImages(): ImageInterface[] {
        const images = this.professional?.profession?.design?.profileImages;
        if (!images) return [];
        return Array.isArray(images) ? images : [images];
    }

    openReviewDialog() {
        const initialState = {
            userDetails: this.userDetails,
            professionalSlug: this.professional?.profession?.seo?.slug
        };
        this.modalService.show(ProfessionalReviewDialogComponent, { initialState, class: 'modal-sm' });
    }

}
